<template>
  <div>
  	<div class="answer-container">
      <question
        :curQuestion="curQuestion"
        :practiceName="examName"
        :curQuestionIndex="curQuestionIndex"
        :qList="qList"
        @optionsChange="optionsChange"
        @btntopre="btnToPre"
        @btntonext="btnToNext"
      ></question>
      <qList
        @QListClick="QListClick"
        @toSub="toSub"
        :qList="qList"
        :duration="duration"
      ></qList>
  	</div>
  </div>
</template>

<script>
  import question from '../../common/question.vue'
  import qList from '../../common/qList.vue'
  import store from '../../vuex/store.js'
  import {getUrlKey, getCookie} from '../../untils/common.js'
  import {ApiGetExamQuestions, ApiGetEQDetail, ApiSaveExamResult} from '../../net/exam/index.js'
  export default {
    data: function () {
      return {
        examId: 0,
        uid: 0,
        duration: 600,
        examName: '', //试卷名
        examDuration: 600, // 试卷时长
        totalScore: 100, // 总分
        passScore: 60, // 及格分数
        curQuestionIndex: 0, // 当前题目在列表中的位置
        qList: [],
        curQuestion: {

        },
      }
    },
    store,
    components:{question, qList},
    computed: {
      questionId: function () {
        return this.qList[this.curQuestionIndex].questionId
      },
      unanswer: function () {
        const unanswerArr = this.qList.filter(Q=>{
          return Q.answerStatus != 2
        })
        return unanswerArr.length
      },
      totalTime: function () {
        const count = this.examDuration - this.duration
        if (count <= 0) { return '00:00'}
        return `${this.PrefixZero(parseInt(count/60),2)}:${this.PrefixZero(count%60,2)}`
      },
    },
    methods: {
      PrefixZero: function (num, n) {
          return (Array(n).join(0) + num).slice(-n);
      },
      getQList: function () {
        const params = {
          examId: this.examId,
          uid: this.uid
        }
        ApiGetExamQuestions(params).then(res=>{
          if (res.code == 200) {
            // console.log('试题列表', res)
            if(res.value.examDuration <= 0){
               this.$alert('该考试已结束', '温馨提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.$router.push(`/Accound`)
                  }
                })
                return
            }
            this.qList = res.value.questions.map(Q=>{
              return {
                ...Q,
                answerStatus: 0, //0是未回答，1是已加载未回答， 2是已回答
                answerResults: 0, //0是未回答，1是回答错误， 2是回答正确
                question: {},
              }
            })
            this.examName = res.value.examName
            this.passScore = res.value.passScore
            this.totalScore = res.value.totalScore
            this.duration = parseInt(res.value.examDuration)*60
            // console.log('1111111',res.value.examDuration)
            this.examDuration = parseInt(res.value.examDuration)*60
            this.setTimer()
            this.getQuestion()
          }

        }).catch(err=>{

        })
      },
      getQuestion: function () {
        const params = {
          examId: this.examId,
          questionId: this.questionId,
          uid: this.uid
        }
        ApiGetEQDetail(params).then(res=>{
           if (res.code == 200) {
             // console.log('获取试题',res)
             const _options = this.handlOption(res)
             this.qList[this.curQuestionIndex].question = {...res.value, options: _options}
             this.qList[this.curQuestionIndex].answerStatus = 1
             this.curQuestion = this.qList[this.curQuestionIndex].question
           }
        }).catch(err=>{

        })

      },
      handlOption: function (res) {
        let _options = []
        if (res.value.questionType == 3) {
          _options = [{option: '1', content: '正确', checked: false}, {option: '2', content: '错误', checked: false}]
        } else {
          _options = JSON.parse(res.value.options).map(item=>{
            let option = '', content = ''
            for (name in item) {
               option = name
               content = item[name]
            }
            return {option, content, checked: false}
          })
        }
        return _options
      },
			optionsChange: function (_options) {
				this.curQuestion.options = _options
        this.qList[this.curQuestionIndex].question = this.curQuestion
        let _studentAnswer = ''
        _options.forEach(O=>{
          if (O.checked) {_studentAnswer+=O.option}
        })
        // console.log('_checkedArr', _studentAnswer)
        this.qList[this.curQuestionIndex].studentAnswer = _studentAnswer
        if (_studentAnswer != '') {
          this.qList[this.curQuestionIndex].answerStatus = 2
          if (_studentAnswer == this.curQuestion.trueAnswer) {
            this.qList[this.curQuestionIndex].answerResults = 2
          } else {
            this.qList[this.curQuestionIndex].answerResults = 1
          }
        } else {
          this.qList[this.curQuestionIndex].answerStatus = 1
          this.qList[this.curQuestionIndex].answerResults = 0
        }

			},
      questionChange: function () {
        if (this.qList[this.curQuestionIndex].answerStatus != 0) {
          // 已经缓存过
          this.curQuestion = this.qList[this.curQuestionIndex].question
        } else {
          //未缓存过
          this.getQuestion()
        }
      },
      QListClick: function (index) {
        this.curQuestionIndex = index
        this.questionChange()
      },
      btnToPre: function () {
        if (this.curQuestionIndex <= 0) {
          this.$message.warning('已经是第一题了')
          return
        }
        this.curQuestionIndex --
        this.questionChange()
      },
      btnToNext: function () {
        if (this.curQuestionIndex >= this.qList.length - 1) {
          this.$message.warning('已经是最后一题了')
          return
        }
        this.curQuestionIndex ++
        this.questionChange()
      },
      setTimer: function () {
        clearInterval(this.timer)
        this.timer = setInterval(()=>{
          this.duration --
          if (this.duration == 0) {
            clearInterval(this.timer)
            this.examSubmit()
          }
        },1000)

        this.$once('hook:beforeDestroy', () => {
            clearInterval(this.timer)
        })
      },
      toSub: function () {
        if (this.unanswer == 0) {
          this.examSubmit()
          return
        }
        this.$confirm(`您还有${this.unanswer}道题未答，确认交卷吗？`, '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.examSubmit()
        }).catch(() => {})
      },
      examSubmit: function () {
       // this.$store.isSubmit = true
        let params = {
          uid: this.uid,
          examId: this.examId,
          totalScore: 0,
          totalTime: this.totalTime,
          current: 0,
          trueCount: 0,
          random: 'bbbbbbbbbbb',
          timeStamp: 0,
          sign: 'wewewewewewewew',
          examAnswerDetail: []
        }
        this.qList.forEach(Q=>{
          if (Q.answerResults == 2) {
            params.totalScore += parseInt(Q.questionScore)
            params.trueCount++
          }
          params.examAnswerDetail.push({
            examId: this.examId,
            questionId: Q.questionId,
            studentAnswer: Q.studentAnswer || '',
            state: Q.answerResults,
            score: Q.answerResults == 2?Q.questionScore:0,
          })
        })
        params.current = parseInt((params.trueCount/this.qList.length)*100)
        ApiSaveExamResult(params).then(res=>{
          if (res.code == 200) {
           // this.$store.state.totalTime = params.totalTime
            this.toResultPage()
          }
        })
      },
      toResultPage: function () {
        this.$router.push(`/Results?eid=${this.examId}`)
      },
    },
    mounted: function () {
      this.examId = getUrlKey('eid',window.location.href) || 0
      if (this.examId == 0) {
         this.$alert('试卷获取失败', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          })
        return
      }

      const _user = getCookie('user')
      if (_user) {
        const user = JSON.parse(_user)
        this.uid = user.uid
      }
      this.getQList()
    }
  }
</script>

<style scoped>
.answer-container{
  width: 1140px;
  margin:0 auto;
  border-radius: 6px;
  margin-top: 24px;
  overflow: hidden;
  margin-bottom: 24px;
}

</style>



// WEBPACK FOOTER //
// src/components/Exam/Exam.vue